export const MAX_FILE_SIZE_MB = 25;

export const ACCEPTED_FILE_TYPES = [
  // PDF
  'application/pdf',

  // Images
  'image/*',

  // Word Doc
  '.doc',
  'application/msword',
  '.docx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

  // Excel Spreadsheet or CSV
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
].join(',');
